import React from "react";
import Headers from "../../../components/Headers";
import { Table, Modal, Button, Tabs, message, Popover, Icon } from "antd";
import "./index.scss";
import NProgress from "nprogress";
import {
  fetchEvaluationDetails,
  fetchEvaluationUserList,
  fetchAudit,
  fetchBonusAct,
} from "../../../api/evaluation";

const { TabPane } = Tabs;
const { Column } = Table;
const BreadCrumbData = [
  { path: "/page/ssry/userInfo", name: "试试如意" },
  { path: "/page/ssry/activityCenter", name: "测评活动中心" },
  { path: "/page/ssry/historyActivityDetails", name: "查看详情" },
];
class HistoryActivityDetails extends React.Component {
  state = {
    activeKey: "1",
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      tryEvaluationGoodsId: this.props.match.params.id,
      state: 0,
    },
    list: [],
    total: 0,
    win_listQuery: {
      pageNum: 1,
      pageSize: 10,
      state: 1,
      tryEvaluationGoodsId: this.props.match.params.id,
    },
    win_list: [],
    win_total: 0,
    bigImgUrl: "",
    bigImgVisible: false,
    info: {},
    currentUser: {},
    confirmVisible: false,
    pass: true,
    canBonus: false,
    bonusState: 0, //发放奖金or取消资格
    bonusVisible: false,
    btnLoading: false,
  };
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    });
  };
  componentDidMount() {
    NProgress.start();
    this.getList();
    this.getInfo();

    NProgress.done();
  }
  getInfo = () => {
    fetchEvaluationDetails(this.state.listQuery.tryEvaluationGoodsId).then(
      (res) => {
        if (res.success) {
          let canBonus = true;
          if (
            new Date(res.data.bonusTime).getTime() >
            new Date(res.data.time).getTime()
          ) {
            canBonus = false;
          }
          res.data.endTime = res.data.endTime.split(" ")[0];
          res.data.bonusTime = res.data.bonusTime.split(" ")[0];
          this.setState({
            info: res.data,
            canBonus,
          });
        }
      }
    );
  };
  getList = () => {
    switch (this.state.activeKey) {
      case "1":
        fetchEvaluationUserList(this.state.listQuery).then((res) => {
          if (res.success) {
            this.setState({
              list: res.data.list,
              total: res.data.total,
            });
          }
        });
        break;
      case "2":
        fetchEvaluationUserList(this.state.win_listQuery).then((res) => {
          if (res.success) {
            this.setState({
              win_list: res.data.list,
              win_total: res.data.total,
            });
          }
        });
        break;
      default:
        break;
    }
  };
  tabsChange = (e) => {
    this.setState(
      {
        activeKey: e,
      },
      () => {
        this.getList();
      }
    );
  };
  setBonus = (value, bonusState) => {
    this.setState({
      bonusVisible: true,
      currentUser: value,
      bonusState,
    });
  };
  bonusCancel = () => {
    this.setState({
      bonusVisible: false,
    });
  };
  bonusOk = () => {
    const { currentUser, bonusState } = this.state;
    this.setState({
      btnLoading: true,
    });
    fetchBonusAct({
      tryUserEvaluationId: currentUser.tryUserEvaluationId,
      operation: bonusState,
    }).then((res) => {
      this.setState({
        btnLoading: false,
      });
      if (res.success) {
        message.success("操作成功");
        this.getList();
        this.bonusCancel();
      }
    });
  };
  showConfirm = (value, pass) => {
    this.setState({
      confirmVisible: true,
      currentUser: value,
      pass,
    });
  };

  confirmCancel = () => {
    this.setState({
      confirmVisible: false,
    });
  };
  confirmOk = () => {
    const { pass, currentUser } = this.state;
    this.setState({
      btnLoading: true,
    });
    fetchAudit({
      tryUserEvaluationId: currentUser.tryUserEvaluationId,
      operation: pass,
    }).then((res) => {
      this.setState({
        btnLoading: false,
      });
      if (res.success) {
        message.success("操作成功");
        this.getList();
        this.confirmCancel();
      }
    });
  };
  render() {
    const {
      listQuery,
      list,
      total,
      win_listQuery,
      win_list,
      win_total,
      info,
      activeKey,
      confirmVisible,
      currentUser,
      pass,
      canBonus,
      bonusVisible,
      bonusState,
      btnLoading,
    } = this.state;

    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div className="historyActivityDetails_container">
          <Button onClick={() => this.props.history.goBack()}>返回</Button>
          <div className="content">
            <div className="row">
              <span className="label">测评商品</span>
              {info.goodsName}
            </div>
            <div className="row">
              <span className="label">活动截止日期</span>
              {info.endTime}
            </div>
            <div className="row">
              <span className="label">奖金发放日期</span>
              {info.bonusTime}
            </div>
            <div className="row">
              <span className="label">审核说明</span>保留{info.retainDay}
              天后，系统在3个工作日内发放对应的现金红包到微信零钱
            </div>
          </div>
          <div className="tabWraps">
            <Tabs activeKey={activeKey} onChange={this.tabsChange}>
              <TabPane tab="参与名单" key="1">
                <Table
                  rowKey="tryUserEvaluationId"
                  dataSource={list}
                  // locale={{ emptyText: "暂无商户" }}
                  pagination={{
                    showTotal: () => `共${total}条`,
                    total: total,
                    current: listQuery.pageNum,
                    pageSize: listQuery.pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "40", "100"],
                    onChange: (page, pageSize) => {
                      this.setState(
                        {
                          listQuery: { ...listQuery, pageNum: page },
                        },
                        () => this.getList()
                      );
                    },
                    onShowSizeChange: (current, pageSize) => {
                      this.setState(
                        {
                          listQuery: { ...listQuery, pageSize, pageNum: 1 },
                        },
                        () => this.getList()
                      );
                    },
                  }}
                >
                  <Column
                    title="上传时间"
                    dataIndex="createTime"
                    key="createTime"
                  />
                  <Column
                    title="用户昵称"
                    dataIndex="nickName"
                    key="nickName"
                  />
                  <Column
                    title="手机号码"
                    dataIndex="mobilePhone"
                    key="mobilePhone"
                  />
                  <Column
                    title="主页链接"
                    className="homeLink"
                    dataIndex="homeLink"
                    key="homeLink"
                    render={(value) =>
                      value ? (
                        <a href={value} target="_blank">
                          {value}
                        </a>
                      ) : (
                        ""
                      )
                    }
                  />
                  <Column
                    title="主页截图"
                    dataIndex="homeScreenshot"
                    key="homeScreenshot"
                    render={(text) => (
                      <img
                        onClick={() => this.showBigImg(text)}
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                        src={text}
                      ></img>
                    )}
                  />
                  <Column
                    title="测评截图"
                    dataIndex="screenshot"
                    key="screenshot"
                    render={(text) => (
                      <img
                        onClick={() => this.showBigImg(text)}
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                        src={text}
                      ></img>
                    )}
                  />
                  <Column
                    title="审核结果"
                    dataIndex="state"
                    key="state"
                    render={(value, record) => {
                      value = Number(value);
                      switch (value) {
                        case 1:
                          return <span style={{ color: "#66B60E" }}>通过</span>;
                          break;
                        case 2:
                          return (
                            <span style={{ color: "#D0021B" }}>未通过</span>
                          );
                          break;
                        default:
                          break;
                      }
                    }}
                  />
                  <Column
                    title="操作"
                    render={(value, record) =>
                      !record.state ? (
                        <>
                          <a
                            onClick={() => this.showConfirm(record, "ADOPT")}
                            className="marginR"
                          >
                            通过
                          </a>
                          <a onClick={() => this.showConfirm(record, "FAILED")}>
                            未通过
                          </a>
                        </>
                      ) : (
                        ""
                      )
                    }
                  />
                </Table>
              </TabPane>
              <TabPane tab="获奖名单" key="2">
                <Table
                  rowKey={() => Math.random()}
                  dataSource={win_list}
                  pagination={{
                    showTotal: () => `共${win_total}条`,
                    total: win_total,
                    current: win_listQuery.pageNum,
                    pageSize: win_listQuery.pageSize,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "40", "100"],
                    onChange: (page, pageSize) => {
                      this.setState(
                        {
                          win_listQuery: { ...win_listQuery, pageNum: page },
                        },
                        () => this.getList()
                      );
                    },
                    onShowSizeChange: (current, pageSize) => {
                      this.setState(
                        {
                          win_listQuery: {
                            ...win_listQuery,
                            pageSize,
                            pageNum: 1,
                          },
                        },
                        () => this.getList()
                      );
                    },
                  }}
                >
                  <Column
                    title="用户昵称"
                    dataIndex="nickName"
                    key="nickName"
                  />
                  <Column
                    title="手机号码"
                    dataIndex="mobilePhone"
                    key="mobilePhone"
                  />
                  <Column
                    title="主页链接"
                    className="homeLink"
                    dataIndex="homeLink"
                    key="homeLink"
                    render={(value) =>
                      value ? (
                        <a href={value} target="_blank">
                          {value}
                        </a>
                      ) : (
                        ""
                      )
                    }
                  />
                  <Column
                    title="主页截图"
                    dataIndex="homeScreenshot"
                    key="homeScreenshot"
                    render={(text) => (
                      <img
                        onClick={() => this.showBigImg(text)}
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                        src={text}
                      ></img>
                    )}
                  />
                  <Column
                    title="测评截图"
                    dataIndex="screenshot"
                    key="screenshot"
                    render={(text) => (
                      <img
                        onClick={() => this.showBigImg(text)}
                        style={{ width: 40, height: 40, cursor: "pointer" }}
                        src={text}
                      ></img>
                    )}
                  />
                  <Column
                    title="上传时间"
                    dataIndex="createTime"
                    key="createTime"
                  />
                  <Column
                    title="奖金状态"
                    dataIndex="bonusState"
                    key="bonusState"
                    render={(value) => {
                      value = Number(value);
                      switch (value) {
                        case 0:
                          return (
                            <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                              未发放
                            </span>
                          );
                          break;
                        case 1:
                          return (
                            <span style={{ color: "#66B60E" }}>已发放</span>
                          );
                          break;
                        case 2:
                          return (
                            <span style={{ color: "#D0021B" }}>已取消</span>
                          );
                          break;
                        default:
                          break;
                      }
                    }}
                  />{" "}
                  <Column
                    title="操作"
                    render={(value, record) =>
                      !record.bonusState ? (
                        canBonus ? (
                          <>
                            <a
                              onClick={() => this.setBonus(value, 0)}
                              className="marginR"
                            >
                              发放奖金
                            </a>
                            <a onClick={() => this.setBonus(value, 1)}>
                              取消资格
                            </a>
                          </>
                        ) : (
                          <Popover
                            content={
                              <div>
                                <Icon
                                  style={{ color: "#D0021B" }}
                                  type="info-circle"
                                  theme="filled"
                                />{" "}
                                未到奖金发放日，暂不能操作
                              </div>
                            }
                            title={null}
                          >
                            <span
                              style={{ color: "rgba(0, 0, 0, 0.45)" }}
                              className="marginR"
                            >
                              发放奖金
                            </span>
                            <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>
                              取消资格
                            </span>
                          </Popover>
                        )
                      ) : (
                        ""
                      )
                    }
                  />
                </Table>
              </TabPane>
            </Tabs>
          </div>
        </div>
        <Modal
          width={700}
          className="confirmAudit"
          title="审核通过确认"
          visible={confirmVisible}
          onOk={this.confirmOk}
          onCancel={this.confirmCancel}
          footer={[
            <Button onClick={this.confirmCancel}>取消</Button>,
            <Button
              type="primary"
              loading={btnLoading}
              onClick={this.confirmOk}
            >
              确定
            </Button>,
          ]}
        >
          <div className="question">?</div>
          确定用户（{currentUser.nickName}）关于（{info.goodsName}
          ）测评审核{pass ? "" : "不"}通过？
        </Modal>
        <Modal
          width={700}
          className="confirmAudit"
          title={bonusState == 0 ? "奖金发放确认" : "资格取消确认"}
          visible={bonusVisible}
          onOk={this.bonusOk}
          onCancel={this.bonusCancel}
          footer={[
            <Button onClick={this.bonusCancel}>取消</Button>,
            <Button type="primary" loading={btnLoading} onClick={this.bonusOk}>
              确定
            </Button>,
          ]}
        >
          <div className="question">?</div>
          {bonusState == 0
            ? `确定给用户（${currentUser.nickName}）发放奖金？确定后系统将直接转账，不可撤回。`
            : `确定将用户（${currentUser.nickName}）的获奖资格取消？取消后自动作废，不可撤回。`}
        </Modal>
        <Modal
          title="图片预览"
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={this.state.bigImgVisible}
          footer={null}
        >
          <img
            style={{ width: "100%", height: "100%" }}
            src={this.state.bigImgUrl}
          ></img>
        </Modal>
      </div>
    );
  }
}

export default HistoryActivityDetails;
